import { format } from 'date-fns';

import type { ICandidacyResponse } from '@/dto';

export const list = [
  {
    label: 'Close Date',
    key: 'candidaciesCloseAt',
    format: (value: string) => format(new Date(value), 'MM/dd/yyyy'),
  },
  {
    label: 'N° Applications',
    key: 'candidacies',
    format: (value: ICandidacyResponse[]) => value.length,
  },
];
